import axiosApi from "./api";

/**
 * 选手扩展表-通过手机号查询
 * @param {string} phone - 选手手机号
 * @returns {Promise} - 返回选手扩展信息
 */
export function getPlayerDetail(phone) {
  return axiosApi({
    url: `/tc/hosp/account/info-by-phone`,
    method: "post",
    data: { phone },
  });
}

/**
 * 发送手机验证码
 * @param {string} phone - 手机号
 * @ret
 */
export function getCode(phone) {
  return axiosApi({
    url: `/tc/hosp/account/sendSmsCode`,
    method: "get",
    params: { phone },
  });
}

/**
 * 手机号验证码验证
 * @param {string} code - 验证码
 * @param {string} phone - 手机号
 * @ret
 */
export function verifySmsCode(code, phone) {
  return axiosApi({
    url: `/tc/hosp/account/verifySmsCode`,
    method: "post",
    data: { phone, code },
  });
}

/**
 * 修改选手信息
 * @param {object} data
 * @ret
 */
export function editUser(data) {
  return axiosApi({
    url: `/tc/hosp/tbContestant/edit`,
    method: "post",
    data: data,
  });
}

/**
 * 新增选手信息
 * @param {object} data
 * @ret
 */
export function addUser(data) {
  return axiosApi({
    url: `/tc/hosp/tbContestant/add`,
    method: "post",
    data: data,
  });
}
